import {
  Avatar,
  RemoveRedEyeOutlined,
  SidePanelDS,
  Spacer,
  TextCapitalized,
} from "@qivia/ui";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { HomeChargingSupportingDocument } from "../../homeChargingSupportingDocumentsAPI";

export const SidePanelSectionBlock = (props: {
  supportingDocument: HomeChargingSupportingDocument;
  firstPath: string;
}) => {
  const navigate = useNavigate();

  return (
    <SidePanelDS.ActionBlock>
      <SidePanelDS.SectionedActionStripe
        left={
          <StyledRowCenter>
            <TextCapitalized>
              <Avatar
                size={"S"}
                color={"orange"}
                firstName={props.supportingDocument.firstName}
                lastName={props.supportingDocument.lastName}
              />
            </TextCapitalized>
            <Spacer x={0.5} />
            {props.supportingDocument.firstName}{" "}
            {props.supportingDocument.lastName}
          </StyledRowCenter>
        }
        right={
          <StyledLittleIcon>
            <RemoveRedEyeOutlined
              key="driver"
              onClick={() =>
                navigate(
                  `/${props.firstPath}/drivers/${props.supportingDocument.driverUuid}?fromNavigate=true`,
                )
              }
            />
            <Spacer x={1} />
          </StyledLittleIcon>
        }
      />
    </SidePanelDS.ActionBlock>
  );
};

const StyledRowCenter = styled.div`
  ${typographies["Body/S"]}
  display: flex;
  align-items: center;
  & svg {
    width: 1rem;
    height: 1rem;
  }
`;

const StyledLittleIcon = styled.div`
  display: flex;
  cursor: pointer;
  & svg {
    width: 1rem;
    height: 1rem;
  }
`;
